export const safeDismiss = async (overlay) => {
  if (!overlay || typeof overlay.dismiss !== "function") return;

  try {
    await overlay.dismiss();
  } catch (error) {
    if (!String(error?.message || error).includes("overlay does not exist")) {
      throw error;
    }
  }
};

export const safeControllerDismiss = async (controller) => {
  if (!controller || typeof controller.dismiss !== "function") return;

  try {
    await controller.dismiss();
  } catch (error) {
    if (!String(error?.message || error).includes("overlay does not exist")) {
      throw error;
    }
  }
};
